import { render, staticRenderFns } from "./SchoolProgram.vue?vue&type=template&id=be851c86&"
import script from "./SchoolProgram.vue?vue&type=script&lang=js&"
export * from "./SchoolProgram.vue?vue&type=script&lang=js&"
import style0 from "./SchoolProgram.vue?vue&type=style&index=0&id=be851c86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports